"use client";

import type { FormInstance, InputRef } from "antd";
import { createContext, useContext } from "react";

import { OpportunityFormValues } from "../types";

export const GlobalNewOpportunityModalContext = createContext<{
  form: FormInstance<OpportunityFormValues & { [key: string]: unknown }> | null;
  oppNameRef?: React.RefObject<InputRef> | null;
  amountRef?: React.RefObject<HTMLInputElement> | null;
  coreFieldsDivRef?: React.RefObject<HTMLDivElement> | null;
}>({
  form: null,
});

export const useGlobalNewOpportunityModalContext = () =>
  useContext(GlobalNewOpportunityModalContext);
